module["exports"] = [
  "كارغو فان",
  "مكشوفة",
  "كوبيه",
  "طاقم الكابينة بيك آب",
  "تمديد الكابينة بيك آب",
  "هاتشباك",
  "ميني فان",
  "سيارة الركاب",
  "سيارة رياضية",
  "سيدان",
  "عربة"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/vehicle/vehicle_type.js
// module id = 2400
// module chunks = 1609